// Micromodal
import MicroModal from 'micromodal';  // es6 module

document.addEventListener('DOMContentLoaded', function (event) {
  if (document.querySelector('.micromodal')) {
    MicroModal.init({
      awaitOpenAnimation: true,	// モーダルオープン時にアニメーションを許可
      awaitCloseAnimation: true,	// モーダルクローズ時にアニメーションを許可
      disableScroll: false,			// bodyのスクロールを禁止
      disableFocus: true			// モーダルオープン時にモーダル内要素にフォーカスさせない
    });
  }

  // 矢印
  if (document.querySelector('.js-modal-pager')) {
    document.querySelectorAll('.js-modal-pager').forEach(pager => {

      // data-modalをdiv. js-modal-pager-itemに付与
      const items = [...pager.querySelectorAll('.js-modal-pager-item')];
      const num = items.length;

      if (num <= 2) {
        pager.classList.add(`--col-${num}`);
      }

      for (let i = 0; i < items.length; i++) {
        items[i].dataset.modal = i
      }

      // PREV
      pager.querySelectorAll('.js-member-modal-prev').forEach(prev => {
        prev.addEventListener('click', function (e) {
          try {
            e.preventDefault();
            e.stopPropagation();
            const currentModalId = e.target.closest('.micromodal').id;
            if (!currentModalId) {
              throw new Error('モーダルが取得できません');
            }
            const currentIdx = e.target.closest('.js-modal-pager-item').dataset.modal;
            if (isNaN(Number(currentIdx))) {
              throw new Error('モーダルインデックスが取得できません');
            }
            const nextModalId = items[getPrevIdx(Number(currentIdx), num)].querySelector('.micromodal').id;
            if (!nextModalId) {
              throw new Error('オープンするモーダルが取得できません');
            }

            // モーダルクローズ
            MicroModal.close(currentModalId);

            // モーダルオープン
            MicroModal.show(nextModalId);

          } catch (err) {
            console.error(err);
          }


        }, false);
      })

      // NEXT
      pager.querySelectorAll('.js-member-modal-next').forEach(next => {
        next.addEventListener('click', function (e) {
          try {
            e.preventDefault();
            e.stopPropagation();
            const currentModalId = e.target.closest('.micromodal').id;
            if (!currentModalId) {
              throw new Error('モーダルが取得できません');
            }
            const currentIdx = e.target.closest('.js-modal-pager-item').dataset.modal;
            if (isNaN(Number(currentIdx))) {
              throw new Error('モーダルインデックスが取得できません');
            }
            const nextModalId = items[getNextIdx(Number(currentIdx), num)].querySelector('.micromodal').id;
            if (!nextModalId) {
              throw new Error('オープンするモーダルが取得できません');
            }

            // モーダルクローズ
            MicroModal.close(currentModalId);

            // モーダルオープン
            MicroModal.show(nextModalId);

          } catch (err) {
            console.error(err);
          }

        }, false);
      })

    })

    function getNextIdx(currentIdx, num) {
      if (currentIdx + 1 >= num) {
        return 0;
      } else {
        return currentIdx + 1;
      }
    }
    function getPrevIdx(currentIdx, num) {
      if (currentIdx === 0) {
        return num - 1;
      } else {
        return currentIdx - 1;
      }
    }

  }

  // モーダル自身のクリック伝番禁止
  if (document.querySelector('.modal__container')) {
    document.querySelectorAll('.modal__container').forEach(modal => {
      // マウス用の伝搬禁止
      modal.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      // タッチ用の伝搬禁止
      modal.addEventListener('touchstart', function (e) {
        e.stopPropagation();
      });

      // 閉じるボタン
      modal.querySelectorAll('[data-micromodal-close]').forEach(close => {
        close.addEventListener('click', closeElmInModal, false);
        close.addEventListener('touchstart', closeElmInModal, false);
      })


      function closeElmInModal(e) {
        e.preventDefault();
        e.stopPropagation();
        const wrapper = e.target.closest('.micromodal');
        if (wrapper && wrapper.id) {
          MicroModal.close(wrapper.id);
        }
      }
    });
  }
});